import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import RegistrationFlow from './RegistrationFlow';

const Root: React.FC = () => {
  return (
    <React.StrictMode>
      <BrowserRouter basename="/registration/accounts/new">
        <RegistrationFlow />
      </BrowserRouter>
    </React.StrictMode>
  );
};

export default Root;
